<nb-card>
  <nb-card-header>
    <span>Rundgänge</span>
    <div class="spacer"></div>
    <div class="tenant-filter">
      <form [formGroup]="form" class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="fullTextSearch" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="status">Status</label>
          <wr-status-select id="status" formControlName="status" [showEmptyOption]="true"></wr-status-select>
        </div>
      </form>
    </div>
  </nb-card-header>
  <wr-table [rows]="inspections()"
            [loading]="isLoading()"
            [(sort)]="sort"
            [rowLink]="getInspectionLink"
  >
    <ng-template column
                 let-inspection
                 [of]="inspections()"
                 header="FolgeNr."
                 shrink
                 sort="continuationNumber">
      <ng-template *ngIf="inspection.continuationNumber > 0">{{inspection.continuationNumber}}</ng-template>
    </ng-template>
    <ng-template column
                 let-inspection
                 [of]="inspections()"
                 header="Datum"
                 shrink
                 sort="fromTimestamp">{{inspection.fromTimestamp | date: 'dd.MM.yyyy'}}</ng-template>
    <ng-template column
                 let-inspection
                 [of]="inspections()"
                 sort="building.sectionText"
                 header="Adresse">{{inspection.building.baseData.sectionText}}</ng-template>
    <wr-table-pagination [totalRows]="inspectionCount()"
                         [(pageSize)]="pageSize"
                         [(page)]="page"></wr-table-pagination>
  </wr-table>
</nb-card>
